export default __webpack_public_path__ + "static/media/RhymesCountAlong_02.c6ef3c71.png";